(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bzz-brand-film"] && !Shopify.designMode) return;
  try {
    function initBrandFilms(){document.querySelectorAll('[data-brand-film]').forEach(video=>{if(video.dataset.ready)return;video.dataset.ready='true';const button=video.parentElement.querySelector('.bzz-film__toggle');const motion=matchMedia('(prefers-reduced-motion: reduce)');button.hidden=false;const sync=()=>{button.textContent=video.paused?button.dataset.play:button.dataset.pause;};video.addEventListener('play',sync);video.addEventListener('pause',sync);button.addEventListener('click',()=>{if(video.paused)video.play().catch(sync);else video.pause();});motion.addEventListener('change',()=>{if(motion.matches)video.pause();});if(!motion.matches&&!navigator.connection?.saveData)video.play().catch(sync);sync();});}
initBrandFilms();document.addEventListener('shopify:section:load',initBrandFilms);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bzz-country-navigation"] && !Shopify.designMode) return;
  try {
    let latestCountryFacetForm = null;
let latestCountrySortField = null;
document.addEventListener('input', (event) => {
  const field = event.target;
  const form = field.closest('facet-filters-form form');
  if (!form) return;
  if (field.name?.startsWith('filter.')) latestCountryFacetForm = form;
  if (field.name === 'sort_by') latestCountrySortField = field;
});
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-bzz-country-link]');
  if (!link) return;
  const base = link.dataset.bzzBaseHref || link.getAttribute('href');
  link.dataset.bzzBaseHref = base;
  const target = new URL(base, window.location.origin);
  const current = new URLSearchParams(window.location.search);
  if (latestCountryFacetForm?.isConnected) {
    const formValues = new URLSearchParams(new FormData(latestCountryFacetForm));
    latestCountryFacetForm.querySelectorAll('price-range input[type="number"]').forEach((field) => {
      const value = Number(field.value);
      const maximum = Number(field.max);
      if (!field.value || (field.name.endsWith('.gte') && value <= 0) || (field.name.endsWith('.lte') && value >= maximum)) formValues.delete(field.name);
      else formValues.set(field.name, field.value);
    });
    for (const key of [...current.keys()]) if (key.startsWith('filter.')) current.delete(key);
    for (const [key, value] of formValues) if (key.startsWith('filter.')) current.append(key, value);
  }
  if (latestCountrySortField?.isConnected) current.set('sort_by', latestCountrySortField.value);
  const keys = new Set(current.keys());
  for (const key of keys) {
    if (key === 'page' || key === 'section_id' || key === 'sections') continue;
    if (target.searchParams.has(key)) continue;
    for (const value of current.getAll(key)) target.searchParams.append(key, value);
  }
  link.href = target.href;
});
  } catch(e) { console.error(e); }
})();

})();
